import { useContext } from 'react';
import PageMetaContext from './PageMetaContext';
import PageMetaProvider from './PageMetaProvider';

export const usePageMetaContext = () => useContext(PageMetaContext);
export default PageMetaProvider;
